/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'wouter';

import styles from '../../../styles/menus/menu.module.css';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string })),
    onClickItem: PropTypes.func,
    className: PropTypes.string,
    itemsClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    activeItemClassName: PropTypes.string,
};

function Menu({
    items = [],
    onClickItem = null,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    activeItemClassName = null,
}) {
    const [location] = useLocation();
    return (
        <nav
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <ul
                className={classNames([
                    styles.items,
                    {
                        [itemsClassName]: itemsClassName !== null,
                    },
                ])}
            >
                {items.map(
                    (
                        {
                            label,
                            url,
                            active = false,
                            external = false,
                            target = '_blank',
                            onClick = null,
                        },
                        index,
                    ) => (
                        <li
                            className={classNames([
                                styles.item,
                                {
                                    [itemClassName]: itemClassName !== null,
                                    [activeItemClassName]:
                                        activeItemClassName !== null &&
                                        (active || location === url),
                                    [styles.active]: active || location === url,
                                },
                            ])}
                            key={`item-${index}`}
                        >
                            {external ? (
                                <a
                                    href={url}
                                    target={target}
                                    className={styles.link}
                                    onClick={onClick || onClickItem}
                                >
                                    {label}
                                </a>
                            ) : (
                                <Link
                                    href={url}
                                    className={styles.link}
                                    onClick={onClick || onClickItem}
                                >
                                    {label}
                                </Link>
                            )}
                        </li>
                    ),
                )}
            </ul>
        </nav>
    );
}

Menu.propTypes = propTypes;

export default Menu;
